/* global Sys, Core, Services */
Sys.ns("Core");

/**
 * The Play Mode Manager model.
 *
 * @class Core.PlayModeManagerModel
 * @extends Core.Model
 */
Core.PlayModeManagerModel = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.PlayModeManagerModel.superclass.constructor.apply(this, arguments);
    },

    /**
     * Add the mode if it does not already exist.
     *
     * @param {string} mode The name of the mode to add.
     * @returns {void}
     */
    addMode: function(mode) {
        var modes = this.readData("modes");

        // if we don' already have the mode in store
        if (modes.indexOf(mode) === -1) {
            modes.push(mode);

            this.storeModeString();
        }
    },

    /**
     * Remove the mode if it exists.
     *
     * @param {string} mode The name of the mode to remove.
     * @returns {void}
     */
    removeMode: function(mode) {
        var modes = this.readData("modes"),
            index = modes.indexOf(mode);

        if (index >= 0) {
            modes.splice(index, 1);

            this.storeModeString();
        }
    },

    /**
     * Get the combined string containing all current modes.
     *
     * @returns {string} Mode string.
     */
    getModeString: function() {
        var modes = this.readData("modes"),
            numModes = modes.length,
            modeString = "",
            i;

        for (i = -1; ++i < numModes;) {
            modeString += ((i > 0) ? "," : "") + modes[i];
        }

        return modeString;
    },

    /**
     * @protected
     * @inheritdoc
     */
    setupData: function() {
        this.storeData("modes", []);
        this.storeModeString();
    },

    /**
     * Place the mode string in global storage.
     *
     * @private
     * @returns {void}
     */
    storeModeString: function() {
        Services.storage.storeData(this.MODULE_NAME + "." + "modes", this.getModeString());
    }
};

Core.PlayModeManagerModel = Sys.extend(Core.Model, Core.PlayModeManagerModel, "Core.PlayModeManagerModel");
